import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import { useTranslation } from "react-i18next";   // ✅ Import i18n

const Chart = () => {
  const { t } = useTranslation();  // ✅ Initialize translation here

  const data = [
    { month: "Jan", progress: 20 },
    { month: "Feb", progress: 50 },
    { month: "Mar", progress: 80 },
    { month: "Apr", progress: 60 },
  ];

  return (
    <div className="card p-4 shadow-sm" style={{ borderRadius: "12px" }}>
      <h5 className="mb-3">{t("Progress")}</h5> {/* ✅ Use translated text */}
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="progress" stroke="#28a745" strokeWidth={3} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Chart;
